var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create-plan",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29207306,6.26904297 L6.29207306,0.741699219 C6.29207306,0.327485656 6.6278595,-0.00830078125 7.04207306,-0.00830078125 C7.45628662,-0.00830078125 7.79207306,0.327485656 7.79207306,0.741699219 L7.79207306,6.26904297 L13.2366531,6.26904297 C13.6508667,6.26904297 13.9866531,6.60482941 13.9866531,7.01904297 C13.9866531,7.43325653 13.6508667,7.76904297 13.2366531,7.76904297 L7.79207306,7.76904297 L7.79207306,13.2416992 C7.79207306,13.6559128 7.45628662,13.9916992 7.04207306,13.9916992 C6.6278595,13.9916992 6.29207306,13.6559128 6.29207306,13.2416992 L6.29207306,7.76904297 L0.73665314,7.76904297 C0.322439577,7.76904297 -0.0133468603,7.43325653 -0.0133468603,7.01904297 C-0.0133468603,6.60482941 0.322439577,6.26904297 0.73665314,6.26904297 L6.29207306,6.26904297 Z",
    id: "icon-create-plan",
    fill: "#6D7A90",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.fb11b45a07eb3a0d6d1d1fd7c3709db1.svg";
export { ForwardRef as ReactComponent };